export default "__VITE_ASSET__CQyc14N3__"